import { createAction, createReducer } from 'deox';

export interface Timeouts {
  /**
   * Number of seconds before displaying the warning dialog during the
   * application phase.
   */
  appWarning: number;

  /**
   * Number of seconds before resetting the application session.
   */
  appTimeout: number;

  /**
   * Number of seconds before displaying the warning dialog in the
   * credit limit screen.
   */
  instantCreditWarning: number;

  /**
   * Number of seconds before navigating away from the credit limit
   * screen.
   */
  instantCreditTimeout: number;

  sessionExtensionsMax: number;

  /**
   * Unified Issuance loading page timeout
   */
  issuanceTimeout: number;

  /**
   * Magic link status timeout
   */
  magicLinkStatusTimeout: number;
}

export interface TimeoutsState {
  entity: Timeouts | null;
}

export interface MountedState {
  timeouts: TimeoutsState;
}

const setTimeouts = createAction(
  'SET_TIMEOUTS',
  resolve => (timeouts: Timeouts) => resolve(timeouts),
);

const defaultState: TimeoutsState = {
  entity: null,
};

const timeoutsReducer = createReducer(defaultState, handleAction => [
  handleAction(setTimeouts, (state, { payload: timeouts }) => ({
    ...state,
    entity: timeouts,
  })),
]);

const selectTimeouts = ({
  timeouts: { entity: timeouts },
}: MountedState): Timeouts => {
  if (!timeouts) throw new Error('Timeouts presence expected');

  return timeouts;
};

export default timeoutsReducer;

export { setTimeouts, selectTimeouts };
